import { Box, Typography } from '@mui/material'
import styles from './EmptyStateBlock.module.scss'

function EmptyStateBlock({ title, description, variant = 'boards' }) {
  return (
    <Box
      className={`${styles.outer} ${
        variant === 'chambers'
          ? styles.outerChambers
          : variant === 'apps'
            ? styles.outerApps
            : styles.outerBoards
      }`}
    >
      <Box
        className={`${styles.inner} ${
          variant === 'chambers'
            ? styles.innerChambers
            : variant === 'apps'
              ? styles.innerApps
              : styles.innerBoards
        }`}
      >
        <Typography
          component="p"
          className={styles.title}
        >
          {title}
        </Typography>
        <Typography
          component="p"
          className={styles.description}
        >
          {description}
        </Typography>
      </Box>
    </Box>
  )
}

export default EmptyStateBlock
